import React from "react";
import { GoStop } from "react-icons/go";

const Light = (props) => {
  return (
    <div className="box">
      <h2>Light </h2>
      <div>
        {6 > 4 ? (
          <div>
            <h1 className="red">ON</h1>
            <GoStop size={30} color="red" className="icon" />
          </div>
        ) : (
          <h1 className="green">OFF</h1>
        )}
      </div>
    </div>
  );
};

export default Light;
